
import CadminCompaniesAx  from 'app/actions/company-admin/companies';
import CadminSlx          from 'app/selectors/company-admin/';
import PageSlx            from 'app/selectors/company-admin/page-settings';
import RoutingSlx         from 'app/selectors/routing';

const Types = {
  LOAD: 'CADMIN_PAGE_SETTINGS_LOAD',
  SAVE_AUTO_MATCHES: 'CADMIN_PAGE_SETTINGS_SAVE_AUTO_MATCHES',
  SAVE_SEARCH_APPROVED_NONPROFITS_ONLY: 'CADMIN_PAGE_SETTINGS_SAVE_SEARCH_APPROVED_NONPROFITS_ONLY',
};

const Actions = {

  load: ({params: {companySlug}}) => (dispatch, getState) => {
    const promise = Promise.all([
      dispatch(CadminCompaniesAx.loadCommon(companySlug)),
    ]);
    return dispatch({type: Types.LOAD, promise});
  },

  saveAutomaticMatches: (automaticMatches) => (dispatch, getState) => {
    const company = CadminSlx.company(getState());
    const promise = dispatch(CadminCompaniesAx.update(company.id, {automaticMatches}));
    return dispatch({type: Types.SAVE_AUTO_MATCHES, promise});
  },

  saveSearchApprovedNonprofitsOnly: (searchApprovedNonprofitsOnly) => (dispatch, getState) => {
    const company = CadminSlx.company(getState());
    const promise = dispatch(CadminCompaniesAx.update(company.id, {searchApprovedNonprofitsOnly}));
    return dispatch({type: Types.SAVE_SEARCH_APPROVED_NONPROFITS_ONLY, promise});
  },

};

export {
  Types,
};

export default Actions;
